import { gql } from '@apollo/client';

export const fetchCampaignsQuery = gql`
  query getCampaigns(
    $campaignFilterInfo: CampaignFilterInfoInput
    $pagination: Pagination
    $search: String
    $sort: Sort
  ) {
    campaigns(
      campaignFilterInfo: $campaignFilterInfo
      pagination: $pagination
      sort: $sort
      search: $search
    ) {
      results {
        id
        name
      }
    }
  }
`;

export const fetchCampaignQuery = gql`
  query getCampaign($campaignId: Long!) {
    campaign(id: $campaignId) {
      id
      name
    }
  }
`;
